import type {
  EngineeringHealthArtifact,
  EngineeringHealthMetric,
} from "@insights/contracts";
import { formatHealthValue } from "./format-health-value";

export function formatEvidenceValue(
  artifact: EngineeringHealthArtifact,
  metric: EngineeringHealthMetric,
) {
  if (metric.id === "build-success") {
    return artifact.detail === "Successful execution" ? "100%" : "0%";
  }

  if (metric.id === "open-pr-wip" || metric.id === "stale-prs") {
    return formatHealthValue(artifact.value, "milliseconds");
  }

  if (metric.id === "review-concentration") {
    const value = formatHealthValue(artifact.value, "count");
    return artifact.value === 1 ? `${value} review` : `${value} reviews`;
  }

  return formatHealthValue(artifact.value, metric.unit);
}
